import {
  product,
  warehouse,
  option,
  customUsershow
} from '../../static/API/API.js'
import axios from 'axios'
let factoryArr = [] //厂家
let materialArr = [] //产品名
let standardArr = [] //规格
let varietyArr = [] //品种
let warehouseArr = [] //仓库
let optionArr = [] //采购类别
let craftArr = [] //工艺
let customUserArr = [] //客户信息
let payment=[]//付款方式
let unitArr=[]//计件单位
let marketArr=[]//销售类别
const publics = async function getdata(companyid) {
  await axios.get(product, {
    params: {
      ope_type: "alone",
      companyid: companyid,
      field: '产品名称'
    }
  }).then(async res => {
    materialArr = res.data
  })
  await axios.get(product, {
    params: {
      ope_type: "alone",
      companyid: companyid,
      field: '规格'
    }
  }).then(async res => {
    standardArr = res.data
  })
  await axios.get(product, {
    params: {
      ope_type: "alone",
      companyid: companyid,
      field: '品种'
    }
  }).then(async res => {
    varietyArr = res.data
  })
  await axios.get(option, {
    params: {
      o_type: "商业伙伴",
      companyid: companyid,
      page_number:1,
      page_size:'all',
    }
  }).then(async res => {
    factoryArr = res.data[0]['pagedata']
  })
  await axios.get(warehouse, {
    params: {
      companyid: companyid,
      page_size: 'all'
    }
  }).then(async res => {
    warehouseArr = res.data
  })
  await axios.get(option, {
    params: {
      o_type: "采购类别",
      companyid: companyid,
      page_size: 'all'
    }
  }).then(async res => {
    optionArr = res.data
  })
  await axios.get(option, {
    params: {
      o_type: "工艺",
      companyid: companyid,
      page_size: 'all'
    }
  }).then(async res => {
    craftArr = res.data
  })
  await axios.get(option, { params: {
      o_type: "付款方式",
      companyid: companyid,
      page_size: 'all'
    }}).then(async res => {
    payment = res.data
  })
  await axios.get(option, { params: {
      o_type: "计件单位",
      companyid: companyid,
      page_size: 'all'
    }}).then(async res => {
    unitArr = res.data
  })
  await axios.get(option, { params: {
      o_type: "销售类别",
      companyid: companyid,
      page_size: 'all'
    }}).then(async res => {
    marketArr = res.data
  })
  let params = new URLSearchParams()
  params.append('page_size', 'all')
  params.append('ope_type', '客户公司')
  params.append('user_id', sessionStorage.getItem('user_id'))
  params.append('companyid', sessionStorage.getItem('companyid'))
  await axios.post(customUsershow, params).then(res => {
    customUserArr = res.data
  })
  // console.log(factoryArr)
  let a = []
  a.materialArr = materialArr
  a.standardArr = standardArr
  a.varietyArr = varietyArr
  a.factoryArr = factoryArr
  a.warehouseArr = warehouseArr
  a.optionArr = optionArr
  a.craftArr = craftArr
  a.customUserArr = customUserArr
  a.payment=payment
  a.unitArr=unitArr
  a.marketArr=marketArr
  return a
};
export {
  publics,
}



// WEBPACK FOOTER //
// ./src/js/public.js